import {CurrencyAmount, CurrencyRounding} from 'util/currency';
import {loadTaxes} from 'services/pricing';
import {TaxType} from 'services/entities/taxes';
import {Discount} from 'services/entities/discounts';


export async function applyCurrencyTaxes(price: CurrencyAmount): Promise<CurrencyAmount> {
  const taxes = await loadTaxes(price.currency!);
  return applyTaxes(price, taxes);
}

export function applyTaxes(price: CurrencyAmount, taxes: TaxType[]): CurrencyAmount {
  for(const tax of taxes) {
    price = price.multiply(1.0 + tax.rate, CurrencyRounding.Down);
  }
  return price;
}

export function applyDiscounts(amount: CurrencyAmount, discounts: Discount[]): CurrencyAmount {
    for (const d of discounts) {
      amount = amount.multiply(1 - d.rate);
    }
    return amount;
}
